// extracted by mini-css-extract-plugin
var _1 = "655px";
export { _1 as "preventCollapseBreakpoint" }
